import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../../elements/Humberg.jsx";

import { useDispatch, useSelector } from "react-redux";
import { allPmmsAction, clearErrors } from "../../../redux/actions/userActions.js";
import SingleUser from "./SingleUser.jsx";
import LoaderBlock from "../../loader/LoaderBlock.jsx";
import { toast } from "react-toastify";
import { UPDATE_USER_STATUS_RESET } from "../../../redux/constants/userConstant.js";
import DateFilter from "../../../elements/DateFilter.jsx";
import { formatNumberShort } from "../../../utils/formatNumberShort.js";

const BalanceOverview = () => {



    const dispatch = useDispatch()

    const { loading, PMMs, totalPMM, totalPages, } = useSelector((state) => state.getPMMs)

    const { error, message } = useSelector(state => state.inviteUser)





    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [perPage, setPerPage] = useState('20');
    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [userType, setUserType] = useState('PMM');
    const [totalPending, setTotalPending] = useState(0);
    const [totalPaid, setTotalPaid] = useState(0);




    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("balance-overview");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        subElement?.classList.add("activeSubLink");

        document.title = `Balance Overview - Admin Panel`;

    }, []);
    // Remove one quantity






    useEffect(() => {

        let query = {}
        if (keyword) query.keyword = keyword
        if (status) query.status = status
        if (perPage) query.perPage = perPage
        if (userType) query.role = userType
        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo
        query.page = page


        dispatch(allPmmsAction(query))

    }, [keyword, status, perPage, page, dispatch, dateTo, dateFrom, userType])



    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: UPDATE_USER_STATUS_RESET })
            dispatch(allPmmsAction())
        }


    }, [error, message, dispatch])



    useEffect(() => {

        if (PMMs?.length > 0) {

            let pendingCal = 0
            let paidCal = 0

            PMMs?.forEach(element => {
                if (userType === "PMM") {
                    pendingCal +=
                        Number(element.pmm_pending_pm_commission || 0)
                        +
                        Number(element.pmm_pending_portal_commission || 0)
                    paidCal +=
                        Number(element.pmm_paid_pm_commission || 0)
                        +
                        Number(element.pmm_paid_portal_commission || 0)
                } else {
                    pendingCal += Number(element.pending_pm_commission || 0)
                    paidCal += Number(element.paid_pm_commission || 0)
                }
            });

            setTotalPending(pendingCal)
            setTotalPaid(paidCal)
        }

    }, [PMMs, userType])






    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"Balance Overview"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                {/* Stat Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax] mb-[2vmax]">
                    <div className="bg-white p-[1.5vmax] shadow-sm rounded-xl border border-gray-100 flex items-center justify-between">
                        <div className="flex flex-col gap-1">
                            <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>{userType}s</span>
                            <span className="text-[1.8vmax] font-bold text-gray-800">{totalPMM || 0}</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-indigo-50 rounded-xl flex items-center justify-center">
                            <i className="fa-solid fa-user text-[1.5vmax] text-indigo-600"></i>
                        </div>
                    </div>

                    <div className="bg-white p-[1.5vmax] shadow-sm rounded-xl border border-gray-100 flex items-center justify-between">
                        <div className="flex flex-col gap-1">
                            <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Pending Amount</span>
                            <span className="text-[1.8vmax] font-bold text-gray-800">Rs. {formatNumberShort(totalPending || 0)}</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-orange-50 rounded-xl flex items-center justify-center">
                            <i className="fa-regular fa-hourglass-half text-[1.5vmax] text-orange-600"></i>
                        </div>
                    </div>

                    <div className="bg-white p-[1.5vmax] shadow-sm rounded-xl border border-gray-100 flex items-center justify-between">
                        <div className="flex flex-col gap-1">
                            <span className='font-medium text-gray-400 uppercase tracking-wider text-[0.8vmax]'>Paid Amount</span>
                            <span className="text-[1.8vmax] font-bold text-gray-800">Rs. {formatNumberShort(totalPaid || 0)}</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-green-50 rounded-xl flex items-center justify-center">
                            <i className="fa-solid fa-check text-[1.5vmax] text-green-600"></i>
                        </div>
                    </div>
                </div>

                <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100">
                    {/* Filters & Search */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax] items-center mb-[2vmax]">
                        <div className="relative">
                            <span className="absolute left-[1vmax] top-1/2 -translate-y-1/2 text-gray-400">
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input 
                                type="text" 
                                className="w-full pl-[2.5vmax] pr-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax]" 
                                placeholder="Search By Name/email"
                                value={keyword}
                                onChange={(e) => {
                                    setKeyword(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>

                        <div className="relative">
                            <span className="absolute left-[1vmax] top-1/2 -translate-y-1/2 text-gray-400">
                                <i className="fa-solid fa-street-view"></i>
                            </span>
                            <select 
                                className="w-full pl-[2.5vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none"
                                value={status}
                                onChange={(e) => {
                                    setStatus(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="">Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="BLOCKED">Blocked</option>
                                <option value="TEMPORARILY_BLOCKED">Temporary Block</option>
                            </select>
                            <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                <i className="fa-solid fa-chevron-down text-xs"></i>
                            </span>
                        </div>

                        <div className="relative">
                            <span className="absolute left-[1vmax] top-1/2 -translate-y-1/2 text-gray-400">
                                <i className="fa-solid fa-list-ul"></i>
                            </span>
                            <select 
                                className="w-full pl-[2.5vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                            </select>
                            <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                <i className="fa-solid fa-chevron-down text-xs"></i>
                            </span>
                        </div>
                    </div>

                    {/* View Type Toggle */}
                    <div className="flex gap-[1vmax] mb-[2vmax] bg-gray-50 p-[0.4vmax] rounded-xl w-fit">
                        <button 
                            className={`text-[0.9vmax] font-bold px-[1.5vmax] py-[0.6vmax] rounded-lg transition-colors ${userType === "PMM" ? "bg-white text-indigo-600 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                            onClick={() => setUserType("PMM")}
                        >
                            View PMM Payments
                        </button>
                        <button 
                            className={`text-[0.9vmax] font-bold px-[1.5vmax] py-[0.6vmax] rounded-lg transition-colors ${userType === "PM" ? "bg-white text-indigo-600 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                            onClick={() => setUserType("PM")}
                        >
                            View PM Earnings
                        </button>
                    </div>
                    <div className="w-full overflow-x-auto">
                        <div className="flex mt-[1vmax] bg-gray-50 py-[1vmax] rounded-lg w-[240%] lg:w-full mb-[1vmax]">
                            <div className="text-center flex-[0.5] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                No.
                            </div>
                            <div className="px-[1vmax] flex-[2] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                Name / Email
                            </div>

                            <div className="text-center px-[0.5vmax] flex-[1] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                User ID
                            </div>

                            <div className="text-center px-[0.5vmax] flex-[1] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                Total Pending
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                Total Paid
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                Status
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.5] text-gray-600 font-bold uppercase text-[0.8vmax]" >
                                Action
                            </div>
                        </div>
                        {loading ?
                            <LoaderBlock />
                            :
                            PMMs?.length > 0 ?
                                PMMs.map((pmm, index) =>
                                    <SingleUser key={pmm.id} PMM={pmm} index={index} totalPMMs={PMMs?.length} userType={userType}
                                    />)
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>

                        }
                    </div>
                </div>


            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

        </Fragment>
    );
};

export default BalanceOverview;
